export const RDX_APP_API_START = 'rdx/app/api/start';
export const RDX_APP_API_END = 'rdx/app/api/end';
export const RDX_APP_API_INIT = 'RDX_APP_API_INIT';
export const RDX_APP_MODULE_START = 'rdx/app/module/start';
export const RDX_APP_MODULE_END = 'rdx/app/module/end';
export const RDX_APP_LOGON = 'rdx/app/logon';
export const RDX_APP_KEEP_ALIVE = 'rdx/app/keepAlive';
export const RDX_APP_LOGOUT = 'rdx/app/logout';
export const RDX_APP_SESSIONTIMEOUT_OPEN = 'rdx/app/sessionTimeout/open';
export const RDX_APP_SESSIONTIMEOUT_RESET = 'rdx/app/sessionTimeout/reset';
export const RDX_APP_SESSIONTIMEOUT_COUNTDOWN = 'rdx/app/sessionTimeout/countdown';
export const RDX_APP_GEN_DSP_AMTOKEN = 'rdx/app/gen/dsp/am/token';

// Loading control
export const startAPI = () => {
	return { 'type': RDX_APP_API_START};
};
export const endAPI = () => {
	return { 'type': RDX_APP_API_END};
};
export const startModule = () => {
	return { 'type': RDX_APP_MODULE_START};
};
export const endModule = () => {
	return { 'type': RDX_APP_MODULE_END};
};

// app initial
export const RDX_APP_PRE_LOGON = 'rdx/app/per/logon';
export const logon = (logonState) => {
	return { 'type': RDX_APP_LOGON, 'logonState': logonState};
};
export const logout = () => {
	return { 'type': RDX_APP_LOGOUT};
};

// session of UI timeout control
export const openSessionTimeout = () => {
	return { 'type': RDX_APP_SESSIONTIMEOUT_OPEN };
};
export const resetSessionTimeout = () => {
	return { 'type': RDX_APP_SESSIONTIMEOUT_RESET };
};
export const startCountdownSessionTimeout = () => {
	return { 'type': RDX_APP_SESSIONTIMEOUT_COUNTDOWN };
};
export const keepAlive = () => {
	return { 'type': RDX_APP_KEEP_ALIVE };
};
export const OPEN_OVERLAY = 'OPEN_OVERLAY';
export const openOverlay = (overlayId) => ({
	type: 'OPEN_OVERLAY',
	overlayId
});

export const CLOSE_OVERLAY = 'CLOSE_OVERLAY';
export const closeOverlay = () => ({
	type: 'CLOSE_OVERLAY'
});

//gen DSP AM token
export const getDspAMToken = (isNavigate) => ({
	type: 'RDX_APP_GEN_DSP_AMTOKEN',
	isNavigate
});
